export const ALGOLIA_STATUS = Object.freeze({
  LOADING: "loading",
  STALLED: "stalled",
  ERROR: "error",
  IDLE: "idle",
});
